import { render, staticRenderFns } from "./CommandmentsDialog.vue?vue&type=template&id=4b148e0b&"
import script from "./CommandmentsDialog.vue?vue&type=script&lang=js&"
export * from "./CommandmentsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports